var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#0065FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6871 29.3172L29.203 21.1883C29.4163 21.0688 29.5939 20.8947 29.7175 20.6838C29.8411 20.4729 29.9062 20.2329 29.9062 19.9885C29.9062 19.7441 29.8411 19.504 29.7175 19.2932C29.5939 19.0823 29.4163 18.9082 29.203 18.7887L14.6871 10.6597C14.4428 10.5229 14.1626 10.4639 13.884 10.4906C13.6053 10.5174 13.3414 10.6285 13.1276 10.8092C12.9138 10.9899 12.7602 11.2316 12.6875 11.5019C12.6147 11.7722 12.6261 12.0583 12.7203 12.3219L15.4583 19.9884L12.7203 27.6551C12.6664 27.8052 12.6388 27.9635 12.6386 28.123C12.6399 28.3624 12.7037 28.5973 12.8235 28.8045C12.9434 29.0117 13.1152 29.1841 13.322 29.3047C13.5288 29.4252 13.7634 29.4898 14.0028 29.492C14.2422 29.4942 14.478 29.4339 14.687 29.3172L14.6871 29.3172ZM16.6729 20.676L21.6884 20.676C21.8707 20.676 22.0456 20.6036 22.1745 20.4746C22.3035 20.3457 22.3759 20.1708 22.3759 19.9885C22.3759 19.8062 22.3035 19.6313 22.1745 19.5024C22.0456 19.3734 21.8707 19.301 21.6884 19.301L16.6729 19.301L14.0159 11.8598L28.5313 19.9885L14.0155 28.1168L16.6729 20.676Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendicon);
export default __webpack_public_path__ + "static/media/sendicon.c89d020efecc1dfa3025c480ce828e70.svg";
export { ForwardRef as ReactComponent };